module.exports = __webpack_public_path__ + "static/livechat4-40149c9262e22f81fa874498aa968bca.png";